import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=c3b52e42"
import script from "./Pricing.vue?vue&type=script&lang=js"
export * from "./Pricing.vue?vue&type=script&lang=js"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=c3b52e42&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3b52e42')) {
      api.createRecord('c3b52e42', component.options)
    } else {
      api.reload('c3b52e42', component.options)
    }
    module.hot.accept("./Pricing.vue?vue&type=template&id=c3b52e42", function () {
      api.rerender('c3b52e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pricing.vue"
export default component.exports